
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1ekWM", function(module, exports) {
$parcel$export(module.exports, "getGlobalErrorCount", () => $288594066c1e2b02$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $288594066c1e2b02$export$2e2bcd8739ae039);

var $glbdM = parcelRequire("glbdM");
let $288594066c1e2b02$var$shouldInitilizeGlobalErrorHandler = true;
let $288594066c1e2b02$var$globalCount = 0;
const $288594066c1e2b02$var$errors = [];
let $288594066c1e2b02$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $288594066c1e2b02$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $288594066c1e2b02$export$ebe081a8c9bf8176(sinkFunc) {
    $288594066c1e2b02$var$push = sinkFunc;
    $288594066c1e2b02$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $288594066c1e2b02$var$errors.length = 0;
}
function $288594066c1e2b02$export$d06c0426664e7c08() {
    return $288594066c1e2b02$var$globalCount;
}
function $288594066c1e2b02$var$handleError(e) {
    $288594066c1e2b02$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $288594066c1e2b02$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $288594066c1e2b02$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $288594066c1e2b02$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch  {}
}
function $288594066c1e2b02$var$handlePromiseRejection(e) {
    $288594066c1e2b02$var$globalCount++;
    if (e.reason instanceof Error) $288594066c1e2b02$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $288594066c1e2b02$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch  {}
}
function $288594066c1e2b02$var$setupUFOGlobalErrorHandler() {
    if ($288594066c1e2b02$var$shouldInitilizeGlobalErrorHandler) {
        (0, $glbdM.bind)(window, {
            type: 'error',
            listener: (e)=>$288594066c1e2b02$var$handleError(e)
        });
        (0, $glbdM.bind)(window, {
            type: 'unhandledrejection',
            listener: $288594066c1e2b02$var$handlePromiseRejection
        });
        $288594066c1e2b02$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$288594066c1e2b02$export$2e2bcd8739ae039 = $288594066c1e2b02$var$setupUFOGlobalErrorHandler;

});

parcelRegister("bDxkI", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $544078106e542562$export$b33b857ad1d9900e);
$parcel$export(module.exports, "installErrorHandler", () => $544078106e542562$export$abd5747ea77ecab9);

var $iqfTZ = parcelRequire("iqfTZ");
const $544078106e542562$var$buffer = [];
let $544078106e542562$var$push = (payload)=>{
    $544078106e542562$var$buffer.push(payload);
};
function $544078106e542562$export$b33b857ad1d9900e(payload) {
    $544078106e542562$var$push(payload);
}
function $544078106e542562$export$abd5747ea77ecab9(handler) {
    if ((0, $iqfTZ.fg)('moving_jira_entry-points_api_under_platform')) {
        $544078106e542562$var$push = handler;
        $544078106e542562$var$buffer.forEach((payload)=>handler(payload));
        $544078106e542562$var$buffer.length = 0;
    }
}

});

parcelRegister("4FR7Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $8560c4c449274cf4$export$2e2bcd8739ae039);

var $Cs8MU = parcelRequire("Cs8MU");

var $7fzie = parcelRequire("7fzie");
var $8560c4c449274cf4$export$2e2bcd8739ae039 = (0, $Cs8MU.default);

});
parcelRegister("7fzie", function(module, exports) {
$parcel$export(module.exports, "useInteractionContext", () => $703995cb91db633d$export$11bcb6e9af2aca35);

var $euxye = parcelRequire("euxye");

var $Cs8MU = parcelRequire("Cs8MU");
function $703995cb91db633d$export$11bcb6e9af2aca35() {
    return (0, $euxye.useContext)((0, $Cs8MU.default));
}

});


parcelRegister("qqoKJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $614393df447d64a5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DefaultInteractionID", () => (parcelRequire("8glX3")).default);

var $euxye = parcelRequire("euxye");

var $8glX3 = parcelRequire("8glX3");

var $cugCA = parcelRequire("cugCA");

var $aXjxw = parcelRequire("aXjxw");

// We use a context to allow modals to have their own lifecycle
const $614393df447d64a5$var$interactionContext = (0, $euxye.createContext)((0, $8glX3.default));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$614393df447d64a5$export$2e2bcd8739ae039 = $614393df447d64a5$var$interactionContext;

});

parcelRegister("2VIRA", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $02eb82c99c044394$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $02eb82c99c044394$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $02eb82c99c044394$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $02eb82c99c044394$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $02eb82c99c044394$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $02eb82c99c044394$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $02eb82c99c044394$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $02eb82c99c044394$export$983b017156c2aee2);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $02eb82c99c044394$export$60c0193054fc3040);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 




var $02eb82c99c044394$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $02eb82c99c044394$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $02eb82c99c044394$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $02eb82c99c044394$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $02eb82c99c044394$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $02eb82c99c044394$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $02eb82c99c044394$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $02eb82c99c044394$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $02eb82c99c044394$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});

parcelRegister("1GhoA", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $00f569892cd0309b$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $00f569892cd0309b$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $00f569892cd0309b$export$2bce4ffdd840e878);

var $iqfTZ = parcelRequire("iqfTZ");

var $jEdal = parcelRequire("jEdal");

var $bQo2U = parcelRequire("bQo2U");

var $8KaYS = parcelRequire("8KaYS");

var $lqMeC = parcelRequire("lqMeC");

var $g6pjy = parcelRequire("g6pjy");

var $1h3Sd = parcelRequire("1h3Sd");

var $7C981 = parcelRequire("7C981");

var $7ooKQ = parcelRequire("7ooKQ");

var $RYBvR = parcelRequire("RYBvR");
var $00f569892cd0309b$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $00f569892cd0309b$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $00f569892cd0309b$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $00f569892cd0309b$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $00f569892cd0309b$var$getPageVisibleState();
        this.traceContext = null;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $1h3Sd.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $7C981.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $00f569892cd0309b$var$getPageVisibleState();
        (0, $7ooKQ.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
        this.startTrace(this.key);
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $7C981.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $7C981.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $7ooKQ.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        this.stopTrace();
        return true;
    }
    startTrace(metricKey) {
        if ((0, $iqfTZ.fg)('uip_bm3_tracing')) {
            let traceContext = (0, $lqMeC.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $8KaYS.generateTraceId)(),
                    spanId: (0, $bQo2U.generateSpanId)()
                };
                (0, $g6pjy.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'bm3.' + metricKey);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $iqfTZ.fg)('uip_bm3_tracing')) (0, $jEdal.clearActiveTrace)();
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $7C981.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $7ooKQ.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type,
            ...(0, $iqfTZ.fg)('uip_bm3_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $00f569892cd0309b$export$2bce4ffdd840e878 ? (0, $RYBvR.UntilExperience).fromMetric(metricOrConfig) : (0, $RYBvR.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $00f569892cd0309b$var$getPageVisibleState();
        this.traceContext = null;
    }
}

});
parcelRegister("jEdal", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $e083e77cc3603ca3$export$17ab21d7be720b);

var $dTrSd = parcelRequire("dTrSd");
function $e083e77cc3603ca3$export$17ab21d7be720b() {
    (0, $dTrSd.state).context = null;
}

});

parcelRegister("bQo2U", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $dc4925d692ffbbd8$export$295213bc4d0c54ad);
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $dc4925d692ffbbd8$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("8KaYS", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $4f1f2258b65b9636$export$dc6d7ea554bcce10);
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $4f1f2258b65b9636$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("g6pjy", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $b02262c97b9d90a6$export$a1002be327997103);

var $gL9hl = parcelRequire("gL9hl");

var $2WiO3 = parcelRequire("2WiO3");

var $dTrSd = parcelRequire("dTrSd");
const $b02262c97b9d90a6$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $2WiO3.getEnvironment)();
            instance = new (0, $gL9hl.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $b02262c97b9d90a6$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $dTrSd.state).context !== null) $b02262c97b9d90a6$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $dTrSd.state).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $dTrSd.state).context = {
        traceId: traceId,
        spanId: spanId
    };
}

});
parcelRegister("2WiO3", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $8dd491290e49430d$export$57570b1603cf6adb);

var $hIipg = parcelRequire("hIipg");
function $8dd491290e49430d$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $hIipg.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $hIipg.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $hIipg.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $hIipg.envType).STAGING;
    return (0, $hIipg.envType).PROD;
}

});


parcelRegister("1h3Sd", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $db01009044576e1e$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $db01009044576e1e$export$df21d285cfcda81e);
const $db01009044576e1e$export$1d17377365286b00 = [
    'ssr'
];
const $db01009044576e1e$export$df21d285cfcda81e = 7500;

});

parcelRegister("7C981", function(module, exports) {
$parcel$export(module.exports, "logger", () => $191af855b4669177$export$af88d00dbe7f521);
const $191af855b4669177$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("7ooKQ", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $0ff17157c97e5a81$export$13e680397ec8f3eb);
class $0ff17157c97e5a81$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $0ff17157c97e5a81$export$13e680397ec8f3eb = new $0ff17157c97e5a81$var$VisibilityChangeObserver();

});

parcelRegister("RYBvR", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $bdf9d943706e9901$export$3fcc0936ee2cc852);
class $bdf9d943706e9901$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $bdf9d943706e9901$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $bdf9d943706e9901$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$bdf9d943706e9901$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$bdf9d943706e9901$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});


parcelRegister("8P8vl", function(module, exports) {
$parcel$export(module.exports, "Route", () => $d284baadaaf11b61$export$e7b0ac011bb776c6);
const $d284baadaaf11b61$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("iPBlg", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $30cd01146fffc916$export$c21a25872e3f5a2b);

var $siTdT = parcelRequire("siTdT");

var $2VIRA = parcelRequire("2VIRA");

var $kjFxm = parcelRequire("kjFxm");

var $3XHZj = parcelRequire("3XHZj");
const $30cd01146fffc916$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $3XHZj.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $2VIRA.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $siTdT.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $kjFxm.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("kjFxm", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $2749b40c7f691162$export$896b6e121bbaec25);

var $1h3Sd = parcelRequire("1h3Sd");

var $7C981 = parcelRequire("7C981");

var $eqNsC = parcelRequire("eqNsC");

var $jBkWN = parcelRequire("jBkWN");

var $8wMNm = parcelRequire("8wMNm");

var $15lwv = parcelRequire("15lwv");

var $jDdqQ = parcelRequire("jDdqQ");

var $5t2QI = parcelRequire("5t2QI");

var $01ecK = parcelRequire("01ecK");

var $jwWpw = parcelRequire("jwWpw");

var $8vzCr = parcelRequire("8vzCr");

var $ctQIq = parcelRequire("ctQIq");

var $bvxev = parcelRequire("bvxev");

var $bWAkN = parcelRequire("bWAkN");

var $5zBTL = parcelRequire("5zBTL");

var $ABow8 = parcelRequire("ABow8");

var $ftWre = parcelRequire("ftWre");

var $ed8EQ = parcelRequire("ed8EQ");

var $406OU = parcelRequire("406OU");

var $7idis = parcelRequire("7idis");

var $6tXCt = parcelRequire("6tXCt");

var $bHPY5 = parcelRequire("bHPY5");

var $hLfR8 = parcelRequire("hLfR8");

var $1XYuo = parcelRequire("1XYuo");

var $lGfgP = parcelRequire("lGfgP");

var $iSdfe = parcelRequire("iSdfe");

var $9e1yA = parcelRequire("9e1yA");

var $eu7Bk = parcelRequire("eu7Bk");

var $04Idu = parcelRequire("04Idu");

var $a8J6w = parcelRequire("a8J6w");

var $5DsXY = parcelRequire("5DsXY");

var $b65P2 = parcelRequire("b65P2");

var $ccrs5 = parcelRequire("ccrs5");

var $hbIwx = parcelRequire("hbIwx");

var $k8Frq = parcelRequire("k8Frq");

var $iMPa4 = parcelRequire("iMPa4");

var $ah9JO = parcelRequire("ah9JO");

var $bkadA = parcelRequire("bkadA");

var $cZYb5 = parcelRequire("cZYb5");

var $2VIRA = parcelRequire("2VIRA");
const $2749b40c7f691162$var$defaultSet = [
    (0, $8vzCr.eventKey),
    (0, $ftWre.eventType),
    (0, $bWAkN.eventProduct),
    (0, $bvxev.eventPopulation),
    (0, $ABow8.eventRoute),
    (0, $01ecK.eventId),
    (0, $ctQIq.eventLocalTime),
    (0, $5zBTL.eventRegion),
    (0, $8wMNm.appFramework),
    (0, $15lwv.appVersion),
    (0, $jDdqQ.bmVersion),
    (0, $b65P2.telemetryBrowser),
    (0, $ccrs5.telemetryCpu),
    (0, $hbIwx.telemetryMemory),
    (0, $k8Frq.telemetryNetwork),
    (0, $5t2QI.customData),
    (0, $ed8EQ.featureFlags),
    (0, $406OU.hostname),
    (0, $04Idu.productCustomData),
    (0, $iMPa4.appTimings),
    (0, $bkadA.resourceTimings),
    (0, $cZYb5.traceContext)
];
const $2749b40c7f691162$var$pageLoadCommon = [
    ...$2749b40c7f691162$var$defaultSet,
    (0, $9e1yA.pageVisibleState),
    (0, $eu7Bk.pageVisibleValue),
    (0, $jwWpw.eventInitial),
    (0, $1XYuo.pageLoadMetrics),
    (0, $ah9JO.bundleEvalTimings)
];
const $2749b40c7f691162$var$initialPageLoadSet = [
    ...$2749b40c7f691162$var$pageLoadCommon,
    (0, $6tXCt.initialPageLoadMetrics),
    (0, $hLfR8.navigationMetrics),
    (0, $5DsXY.ssrSuccess),
    (0, $a8J6w.ssrFeatureFlags)
];
const $2749b40c7f691162$var$spaTransitionSet = [
    ...$2749b40c7f691162$var$pageLoadCommon
];
const $2749b40c7f691162$var$pageSegmentLoadSet = [
    ...$2749b40c7f691162$var$defaultSet,
    (0, $lGfgP.pageSegmentLoadMetrics),
    (0, $9e1yA.pageVisibleState),
    (0, $eu7Bk.pageVisibleValue),
    (0, $jwWpw.eventInitial),
    (0, $ah9JO.bundleEvalTimings)
];
const $2749b40c7f691162$var$interactionSet = [
    ...$2749b40c7f691162$var$defaultSet,
    (0, $9e1yA.pageVisibleState),
    (0, $eu7Bk.pageVisibleValue),
    (0, $bHPY5.interactionMetrics)
];
const $2749b40c7f691162$var$customMetricSet = [
    ...$2749b40c7f691162$var$defaultSet,
    (0, $9e1yA.pageVisibleState),
    (0, $eu7Bk.pageVisibleValue),
    (0, $7idis.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $2749b40c7f691162$var$webVitalsMetricSet = [
    ...$2749b40c7f691162$var$defaultSet,
    (0, $iSdfe.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $2749b40c7f691162$var$waitForCLS = (delay = (0, $1h3Sd.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $2749b40c7f691162$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $7C981.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $2VIRA.BMEventsType).PAGE_LOAD && (0, $eqNsC.isPageLoadMetricData)(data) && data.isInitial) set = $2749b40c7f691162$var$initialPageLoadSet;
    if (data.config.type === (0, $2VIRA.BMEventsType).PAGE_LOAD && (0, $eqNsC.isPageLoadMetricData)(data) && !data.isInitial) set = $2749b40c7f691162$var$spaTransitionSet;
    if (data.config.type === (0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD && (0, $jBkWN.isPageSegmentLoadMetricData)(data)) set = $2749b40c7f691162$var$pageSegmentLoadSet;
    if (data.config.type === (0, $2VIRA.BMEventsType).INLINE_RESULT) set = $2749b40c7f691162$var$interactionSet;
    if (data.config.type === (0, $2VIRA.BMEventsType).CUSTOM) set = $2749b40c7f691162$var$customMetricSet;
    if (data.config.type === (0, $2VIRA.BMEventsType).WEB_VITALS) {
        set = $2749b40c7f691162$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $2749b40c7f691162$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("eqNsC", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $6f23377e2295fca8$export$b0e12e7abb0bff11);

var $2VIRA = parcelRequire("2VIRA");
const $6f23377e2295fca8$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $2VIRA.BMEventsType).PAGE_LOAD;
};

});

parcelRegister("jBkWN", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $333106b37e7f9d69$export$83d0099ee6dbb5b0);

var $2VIRA = parcelRequire("2VIRA");
const $333106b37e7f9d69$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD;
};

});

parcelRegister("8wMNm", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $458d87362293dfca$export$e34e4529b979f74c);
const $458d87362293dfca$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("15lwv", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $53c28ee304de0ddf$export$82ae485178b37419);
const $53c28ee304de0ddf$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("jDdqQ", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $c220c56d6a31ee8c$export$5cafa465fc876895);
const $c220c56d6a31ee8c$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("5t2QI", function(module, exports) {
$parcel$export(module.exports, "customData", () => $d39ea8bcebf777c0$export$f7e743c7db162193);
const $d39ea8bcebf777c0$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("01ecK", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $de1a3f8519381bfb$export$aed28df7ac07d79a);
const $de1a3f8519381bfb$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("jwWpw", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $a986efa905dc1cbb$export$fa8e91d436b3ef8b);

var $eqNsC = parcelRequire("eqNsC");

var $jBkWN = parcelRequire("jBkWN");
const $a986efa905dc1cbb$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $eqNsC.isPageLoadMetricData)(data) && !(0, $jBkWN.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("8vzCr", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $6f3e0b6b76caceff$export$10be2d3a558d3f88);

var $lgB51 = parcelRequire("lgB51");
const $6f3e0b6b76caceff$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $lgB51.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("lgB51", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $aefece35bec59732$export$b334d07f11140768);

var $2VIRA = parcelRequire("2VIRA");
const $aefece35bec59732$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $2VIRA.BMEventsType).CUSTOM:
            return (0, $2VIRA.StorableBMEventsType).CUSTOM;
        case (0, $2VIRA.BMEventsType).INLINE_RESULT:
            return (0, $2VIRA.StorableBMEventsType).INLINE_RESULT;
        case (0, $2VIRA.BMEventsType).PAGE_LOAD:
            return (0, $2VIRA.StorableBMEventsType).PAGE_LOAD;
        case (0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $2VIRA.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $2VIRA.BMEventsType).WEB_VITALS:
            return (0, $2VIRA.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("ctQIq", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $5832a027b644a32f$export$5219854ae7ec45da);

var $dYbSv = parcelRequire("dYbSv");
const $5832a027b644a32f$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $dYbSv.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $dYbSv.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("bvxev", function(module, exports) {
$parcel$export(module.exports, "eventPopulation", () => $de83cdb4445e4f08$export$9086dbeda9b1d633);
const $de83cdb4445e4f08$export$9086dbeda9b1d633 = (_config, _data, globalConfig)=>{
    if (!globalConfig.population) return {};
    return {
        'event:population': `${globalConfig.population}`
    };
};

});

parcelRegister("bWAkN", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $8c1c251eba31203b$export$a7df4e8088db8843);
const $8c1c251eba31203b$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("5zBTL", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $bb7a6d82e2502130$export$d0117b71adcdebc0);
const $bb7a6d82e2502130$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("ABow8", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $a0169a56ebd6f61d$export$44d3627af289ca16);
const $a0169a56ebd6f61d$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("ftWre", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $7cef50ed34237203$export$4c045e605d532c98);

var $lgB51 = parcelRequire("lgB51");
const $7cef50ed34237203$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $lgB51.mapEventType)(config.type)
    };
};

});

parcelRegister("ed8EQ", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $db80e9a861262694$export$e62953d023125748);
const $db80e9a861262694$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("406OU", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $d1f0b3166d2d92bb$export$640106f6dc7d2706);
const $d1f0b3166d2d92bb$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("7idis", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $a6a10f01210f5de9$export$cab039265c52a2e9);

var $9gsz3 = parcelRequire("9gsz3");
const $a6a10f01210f5de9$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $9gsz3.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});
parcelRegister("9gsz3", function(module, exports) {
$parcel$export(module.exports, "isCustomConfig", () => $0ef165c3b2830171$export$b493eb8b2ba87421);

var $2VIRA = parcelRequire("2VIRA");
const $0ef165c3b2830171$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $2VIRA.BMEventsType).CUSTOM;
};

});


parcelRegister("6tXCt", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $5be3c65c33686908$export$cc95aa3f6ea8e5cb);
const $5be3c65c33686908$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("bHPY5", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $ca08f831b93f660d$export$86db56030b57ba34);

var $1pyUq = parcelRequire("1pyUq");

var $iMmrY = parcelRequire("iMmrY");

var $2VIRA = parcelRequire("2VIRA");
const $ca08f831b93f660d$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $iMmrY.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $2VIRA.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $1pyUq.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $2VIRA.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $2VIRA.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $1pyUq.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});
parcelRegister("1pyUq", function(module, exports) {
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $bbc73210917c15d5$export$b10c1d9a7db7765b);
const $bbc73210917c15d5$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};

});

parcelRegister("iMmrY", function(module, exports) {
$parcel$export(module.exports, "isInteractionConfig", () => $fbe53a9476109297$export$ae68674b6a9353be);

var $2VIRA = parcelRequire("2VIRA");
const $fbe53a9476109297$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $2VIRA.BMEventsType).INLINE_RESULT;
};

});


parcelRegister("hLfR8", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $e9e90aaffb4b2335$export$b88d990436be0f8a);
const $e9e90aaffb4b2335$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("1XYuo", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $35a216fb14a0eef5$export$2878bf482e539059);

var $6YAlc = parcelRequire("6YAlc");

var $cNn4s = parcelRequire("cNn4s");

var $2VIRA = parcelRequire("2VIRA");
const $35a216fb14a0eef5$var$getThreshold = (isInitial, metric)=>{
    return (0, $6YAlc.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $35a216fb14a0eef5$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $35a216fb14a0eef5$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $cNn4s.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $2VIRA.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $35a216fb14a0eef5$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $35a216fb14a0eef5$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $35a216fb14a0eef5$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $35a216fb14a0eef5$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $35a216fb14a0eef5$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $35a216fb14a0eef5$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});
parcelRegister("6YAlc", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $2fa14a4b9b020273$export$5866f95702a15142);
const $2fa14a4b9b020273$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("cNn4s", function(module, exports) {
$parcel$export(module.exports, "isPageLoadConfig", () => $e16957a9bf125d30$export$8672fa27ba8bba88);

var $2VIRA = parcelRequire("2VIRA");
const $e16957a9bf125d30$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $2VIRA.BMEventsType).PAGE_LOAD;
};

});


parcelRegister("lGfgP", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $47733714e40fbd7b$export$ba86cb47f2f22db5);

var $2F5Rx = parcelRequire("2F5Rx");

var $lVxuo = parcelRequire("lVxuo");

var $3QJKP = parcelRequire("3QJKP");

var $2VIRA = parcelRequire("2VIRA");
const $47733714e40fbd7b$var$getThreshold = (isInitial, metric)=>{
    return (0, $2F5Rx.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $47733714e40fbd7b$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $47733714e40fbd7b$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $lVxuo.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $2VIRA.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $47733714e40fbd7b$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $47733714e40fbd7b$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $47733714e40fbd7b$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $47733714e40fbd7b$var$getHistogram(data.isInitial, (0, $2VIRA.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $47733714e40fbd7b$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $47733714e40fbd7b$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $2VIRA.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $2VIRA.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $3QJKP.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $2VIRA.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});
parcelRegister("2F5Rx", function(module, exports) {
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $b174ad87af800504$export$f087a59bd717e49d);
const $b174ad87af800504$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};

});

parcelRegister("lVxuo", function(module, exports) {
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $8ae3a4514b765078$export$abe063537ef4987b);

var $2VIRA = parcelRequire("2VIRA");
const $8ae3a4514b765078$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD;
};

});

parcelRegister("3QJKP", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $e3addcbd76fbc539$export$24b7a1a311eb05dc);

var $2VIRA = parcelRequire("2VIRA");

var $1GhoA = parcelRequire("1GhoA");

var $8ecYH = parcelRequire("8ecYH");
class $e3addcbd76fbc539$export$9609608c00ea5077 extends (0, $8ecYH.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $1GhoA.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $e3addcbd76fbc539$export$24b7a1a311eb05dc = new $e3addcbd76fbc539$export$9609608c00ea5077({
    type: (0, $2VIRA.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("8ecYH", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $0539ae9b3724c2c7$export$fd1447b187f590fe);

var $7C981 = parcelRequire("7C981");

var $1GhoA = parcelRequire("1GhoA");
class $0539ae9b3724c2c7$export$fd1447b187f590fe extends (0, $1GhoA.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $7C981.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $1GhoA.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $7C981.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $7C981.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $1GhoA.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $0539ae9b3724c2c7$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0539ae9b3724c2c7$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($0539ae9b3724c2c7$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});



parcelRegister("iSdfe", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $225d8e6e2fc60690$export$3731db279f590f30);

var $1GhoA = parcelRequire("1GhoA");

var $7ooKQ = parcelRequire("7ooKQ");

var $eu7Bk = parcelRequire("eu7Bk");

var $arbVL = parcelRequire("arbVL");
const $225d8e6e2fc60690$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $1GhoA.PageVisibleState).MIXED;
    };
    (0, $7ooKQ.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await (0, $arbVL.webVitalsMetricCustomTimeout)(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $7ooKQ.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $eu7Bk.pageVisibleValue)(config, data, globalConfig)
    };
};

});
parcelRegister("eu7Bk", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $5fbefe6160ee353e$export$177b923114656380);

var $1GhoA = parcelRequire("1GhoA");

var $2VIRA = parcelRequire("2VIRA");
const $5fbefe6160ee353e$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $2VIRA.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $1GhoA.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});

parcelRegister("arbVL", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetricCustomTimeout", () => $ba3e94ebed6fa51a$export$193ae490b52081dd);

var $6jCVr = parcelRequire("6jCVr");
const $ba3e94ebed6fa51a$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $6jCVr.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $6jCVr.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $6jCVr.webVitalsObserver).data;
};

});
parcelRegister("6jCVr", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $c3e2495872e1c78b$export$253d38dccbb37615);


class $c3e2495872e1c78b$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("ivPwk"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("lAxk5"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $c3e2495872e1c78b$export$253d38dccbb37615 = new $c3e2495872e1c78b$var$WebVitalsObserver();

});
parcelRegister("ivPwk", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6tnv3").then(()=>parcelRequire('6CwtU'));

});
parcelRegister("4cvLQ", function(module, exports) {
"use strict";

function $30f0ed6275c09e08$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("96thM")).resolve(id));
}
module.exports = $30f0ed6275c09e08$var$load;

});
parcelRegister("96thM", function(module, exports) {
$parcel$export(module.exports, "register", () => $6a0b641ff72a0641$export$6503ec6e8aabbaf, (v) => $6a0b641ff72a0641$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $6a0b641ff72a0641$export$f7ad0328861e2f03, (v) => $6a0b641ff72a0641$export$f7ad0328861e2f03 = v);
var $6a0b641ff72a0641$export$6503ec6e8aabbaf;
var $6a0b641ff72a0641$export$f7ad0328861e2f03;
"use strict";
var $6a0b641ff72a0641$var$mapping = new Map();
function $6a0b641ff72a0641$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6a0b641ff72a0641$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6a0b641ff72a0641$var$resolve(id) {
    var resolved = $6a0b641ff72a0641$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6a0b641ff72a0641$export$6503ec6e8aabbaf = $6a0b641ff72a0641$var$register;
$6a0b641ff72a0641$export$f7ad0328861e2f03 = $6a0b641ff72a0641$var$resolve;

});



parcelRegister("lAxk5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bXfdu").then(()=>parcelRequire('ktuHO'));

});




parcelRegister("9e1yA", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $a5ee3daffa427366$export$723b4c298aca63af);
const $a5ee3daffa427366$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("04Idu", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $e5c0d4822f94a6c4$export$fa2af6e412815a74);
const $e5c0d4822f94a6c4$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("a8J6w", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $0c11f71ac7fa48ef$export$fdbea518c19dfa8);

var $2VIRA = parcelRequire("2VIRA");
const $0c11f71ac7fa48ef$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $0c11f71ac7fa48ef$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $2VIRA.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $2VIRA.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $2VIRA.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $0c11f71ac7fa48ef$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("5DsXY", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $38346e24cc72bb07$export$a3dc8251cf55b2e0);
const $38346e24cc72bb07$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("b65P2", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $e7213e3556d514f9$export$386b10ac64a50b1);

var $9njAx = parcelRequire("9njAx");
const $e7213e3556d514f9$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9njAx))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($9njAx))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("ccrs5", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $de727a4a07d7f7a4$export$9f84cb359ed29139);
const $de727a4a07d7f7a4$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("hbIwx", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $a818e1f1ffb471d9$export$496c14d72b257e07);
const $a818e1f1ffb471d9$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("k8Frq", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $23d45ecb47217be9$export$88bf7b55f7fc4e8e);
const $23d45ecb47217be9$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("iMPa4", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $a71ef45f6b09e8ea$export$e952f50a4f2d02da);

var $2VIRA = parcelRequire("2VIRA");

var $81XUC = parcelRequire("81XUC");

var $4pKa2 = parcelRequire("4pKa2");
const $a71ef45f6b09e8ea$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $2VIRA.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $81XUC.customTimings)(config, data);
    const ssr = config.type === (0, $2VIRA.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $4pKa2.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("81XUC", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $0a5ac3b293567ca9$export$6126f85083a72c6e);

const $0a5ac3b293567ca9$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $0a5ac3b293567ca9$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $0a5ac3b293567ca9$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $0a5ac3b293567ca9$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $c3b876b1e2716851$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $c3b876b1e2716851$export$b98e411ae80c806f = '/';


parcelRegister("4pKa2", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $0280d07302f65977$export$130f411261a599c5);

const $0280d07302f65977$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $0280d07302f65977$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $0280d07302f65977$var$SSR_PREFIX = 'ssr';
const $0280d07302f65977$var$mapKey = (key)=>{
    if (key === 'total') return $0280d07302f65977$var$SSR_PREFIX;
    return `${$0280d07302f65977$var$SSR_PREFIX}${0, $c3b876b1e2716851$export$b98e411ae80c806f}${key}`;
};
const $0280d07302f65977$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($0280d07302f65977$var$filterEntry(entry[1])) acc[$0280d07302f65977$var$mapKey(entry[0])] = $0280d07302f65977$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("ah9JO", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $575da97e5abdfe39$export$1a2bb347935fc536);
const $575da97e5abdfe39$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $575da97e5abdfe39$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($575da97e5abdfe39$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("bkadA", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $fd56290bf858e94f$export$81a7d52441a06b50);
const $fd56290bf858e94f$var$cacheableTypes = [
    'script',
    'link'
];
const $fd56290bf858e94f$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $fd56290bf858e94f$var$CACHE_NETWORK = 'network';
const $fd56290bf858e94f$var$CACHE_MEMORY = 'memory';
const $fd56290bf858e94f$var$CACHE_DISK = 'disk';
const $fd56290bf858e94f$var$calculateTransferType = (type, duration, size)=>{
    if (!$fd56290bf858e94f$var$cacheableTypes.includes(type)) return $fd56290bf858e94f$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $fd56290bf858e94f$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $fd56290bf858e94f$var$CACHE_DISK;
    if (size === undefined) return null;
    return $fd56290bf858e94f$var$CACHE_NETWORK;
};
const $fd56290bf858e94f$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$fd56290bf858e94f$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $fd56290bf858e94f$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $fd56290bf858e94f$var$withoutHeaders = ()=>false;
const $fd56290bf858e94f$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $fd56290bf858e94f$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $fd56290bf858e94f$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $fd56290bf858e94f$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $fd56290bf858e94f$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $fd56290bf858e94f$var$getNetworkData = (item, eventStart, hasTimingHeaders = $fd56290bf858e94f$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$fd56290bf858e94f$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($fd56290bf858e94f$var$cacheableTypes.includes(type)) {
        const transferType = $fd56290bf858e94f$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$fd56290bf858e94f$var$getSizeObject(size)
        };
        if (transferType !== $fd56290bf858e94f$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$fd56290bf858e94f$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$fd56290bf858e94f$var$getSizeObject(size)
    };
};
const $fd56290bf858e94f$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $fd56290bf858e94f$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $fd56290bf858e94f$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$fd56290bf858e94f$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$fd56290bf858e94f$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});

parcelRegister("cZYb5", function(module, exports) {
$parcel$export(module.exports, "traceContext", () => $ae738e579ac17c2f$export$90f20fc1d8cfb95b);
const $ae738e579ac17c2f$export$90f20fc1d8cfb95b = (_config, data, _globalConfig)=>{
    if (!data.traceContext) return null;
    return {
        tracingContext: {
            'X-B3-TraceId': data.traceContext.traceId,
            'X-B3-SpanId': data.traceContext.spanId
        }
    };
};

});


parcelRegister("3XHZj", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $14b3e12e31bb31bb$export$5b4fb14409a2a825);

var $2VIRA = parcelRequire("2VIRA");
const $14b3e12e31bb31bb$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $14b3e12e31bb31bb$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $2VIRA.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($14b3e12e31bb31bb$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $14b3e12e31bb31bb$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $2VIRA.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $2VIRA.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $2VIRA.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $2VIRA.BMEventsType).PAGE_LOAD]: $14b3e12e31bb31bb$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2VIRA.BMEventsType).PAGE_LOAD]),
        [(0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD]: $14b3e12e31bb31bb$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2VIRA.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $2VIRA.BMEventsType).INLINE_RESULT]: $14b3e12e31bb31bb$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2VIRA.BMEventsType).INLINE_RESULT]),
        [(0, $2VIRA.BMEventsType).CUSTOM]: $14b3e12e31bb31bb$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2VIRA.BMEventsType).CUSTOM]),
        [(0, $2VIRA.BMEventsType).WEB_VITALS]: $14b3e12e31bb31bb$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2VIRA.BMEventsType).WEB_VITALS])
    };
};

});


parcelRegister("3zdd0", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $9824d7789f9697cc$export$9e87a201397ac0a9);
const $9824d7789f9697cc$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $9824d7789f9697cc$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("ev3CP", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $a389d74cb69f28fa$export$15e172712955e18f);
const $a389d74cb69f28fa$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("lqMTs", function(module, exports) {
$parcel$export(module.exports, "experiencePayloadEvent", () => $7f6393254e8394df$export$7c957416596ca127);

var $1jtaq = parcelRequire("1jtaq");
const $7f6393254e8394df$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $1jtaq.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("1jtaq", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $96e2a6bacd42342d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $96e2a6bacd42342d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $96e2a6bacd42342d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $96e2a6bacd42342d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $96e2a6bacd42342d$export$837e0f79a8056912);
var $96e2a6bacd42342d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $96e2a6bacd42342d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $96e2a6bacd42342d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $96e2a6bacd42342d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $96e2a6bacd42342d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $96e2a6bacd42342d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $96e2a6bacd42342d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $96e2a6bacd42342d$export$9f2bf58999404c75 = 'fmp';
const $96e2a6bacd42342d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("cTH3O", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $6af845c6224a6f51$export$6123a44dc2384540);

var $7NjC3 = parcelRequire("7NjC3");
const $6af845c6224a6f51$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7NjC3.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};

});
parcelRegister("7NjC3", function(module, exports) {
$parcel$export(module.exports, "MAX_EARLY_QUEUE_LENGTH", () => $f262fb6c2e32d015$export$d8b468db8a225bc9);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 




const $f262fb6c2e32d015$export$d8b468db8a225bc9 = 250;

});


parcelRegister("1WGPj", function(module, exports) {
$parcel$export(module.exports, "ufowarn", () => $cc52682dec2d5478$export$d53d07b6034c4560);

var $d4ULW = parcelRequire("d4ULW");
const $cc52682dec2d5478$export$d53d07b6034c4560 = (...args)=>{
    (0, $d4ULW.ufologger).warn(...args);
};

});
parcelRegister("d4ULW", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $24b33b3077d62e18$export$4ab84f6f04f6566d);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

class $24b33b3077d62e18$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($24b33b3077d62e18$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($24b33b3077d62e18$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $24b33b3077d62e18$export$4ab84f6f04f6566d = new $24b33b3077d62e18$var$UFOLogger();

});


parcelRegister("dqaa1", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $4b1e3da628362298$export$b4958caff08a0960);

var $d4ULW = parcelRequire("d4ULW");
const $4b1e3da628362298$export$b4958caff08a0960 = (...args)=>{
    (0, $d4ULW.ufologger).log(...args);
};

});

parcelRegister("6vrYI", function(module, exports) {
$parcel$export(module.exports, "subscribeEvent", () => $a6ab6f353496faa4$export$37863216db4b714d);

var $1jtaq = parcelRequire("1jtaq");
const $a6ab6f353496faa4$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $1jtaq.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("a9ObK", function(module, exports) {
$parcel$export(module.exports, "unsubscribeEvent", () => $5f17e9c16d809c43$export$ee1a7bd1fc9ea85e);

var $1jtaq = parcelRequire("1jtaq");
const $5f17e9c16d809c43$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $1jtaq.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};

});

parcelRegister("jQqmM", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d4008c32a0ede67a$export$13e680397ec8f3eb);

var $ev3CP = parcelRequire("ev3CP");
class $d4008c32a0ede67a$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $ev3CP.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d4008c32a0ede67a$export$13e680397ec8f3eb = new $d4008c32a0ede67a$var$VisibilityChangeObserver();

});

parcelRegister("ipvkO", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $4891eb5b017d7be0$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $4891eb5b017d7be0$export$cc26007c03242fff);
var $4891eb5b017d7be0$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $4891eb5b017d7be0$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("7VWGN", function(module, exports) {
$parcel$export(module.exports, "default", () => $efd8183323d47072$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $efd8183323d47072$var$UFORouteName = {
    current: null
};
var $efd8183323d47072$export$2e2bcd8739ae039 = $efd8183323d47072$var$UFORouteName;

});

parcelRegister("9yf7o", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $ec2b183e58a54869$export$c08e7affcf78b064);

var $3zdd0 = parcelRequire("3zdd0");

var $7C981 = parcelRequire("7C981");

var $3QJKP = parcelRequire("3QJKP");

var $7ooKQ = parcelRequire("7ooKQ");

var $6jCVr = parcelRequire("6jCVr");

var $8P8vl = parcelRequire("8P8vl");

var $iPBlg = parcelRequire("iPBlg");

var $2VIRA = parcelRequire("2VIRA");
const $ec2b183e58a54869$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $7ooKQ.visibilityChangeObserver).start();
            if (config.events[(0, $2VIRA.BMEventsType).WEB_VITALS]?.enabled) (0, $6jCVr.webVitalsObserver).start();
            if (config.debug) {
                (0, $7C981.logger).enable();
                (0, $iPBlg.submitter).setDebug(true);
                (0, $3QJKP.pageLoadMetaMetric).setDebug(true);
            }
            (0, $iPBlg.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $3zdd0.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $8P8vl.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $3QJKP.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $3QJKP.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $3QJKP.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $3QJKP.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $3QJKP.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $3QJKP.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $ec2b183e58a54869$export$c08e7affcf78b064 = $ec2b183e58a54869$var$makeBrowserMetrics();

});

parcelRegister("kKbVr", function(module, exports) {
$parcel$export(module.exports, "sinkTerminalErrorHandler", () => $a29e23912143b493$export$e5fa3ac6dc44efff);
$parcel$export(module.exports, "useReportTerminalError", () => $a29e23912143b493$export$79ee0f0d40355053);

var $euxye = parcelRequire("euxye");

var $lvzrB = parcelRequire("lvzrB");

var $7fzie = parcelRequire("7fzie");

var $siTdT = parcelRequire("siTdT");

var $7VWGN = parcelRequire("7VWGN");

var $2jbI6 = parcelRequire("2jbI6");
let $a29e23912143b493$var$sinkHandlerFn = ()=>{};
function $a29e23912143b493$export$e5fa3ac6dc44efff(fn) {
    $a29e23912143b493$var$sinkHandlerFn = fn;
}
const $a29e23912143b493$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $a29e23912143b493$export$1a949ef92fd30eca = (error)=>error.name === $a29e23912143b493$var$RELAY_NETWORK_ERRORS_NAME;
const $a29e23912143b493$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $a29e23912143b493$var$getErrorStatusCode = (error)=>{
    if (!$a29e23912143b493$var$isErrorObject(error)) return undefined;
    if ($a29e23912143b493$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $a29e23912143b493$var$getErrorTraceId = (error)=>$a29e23912143b493$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $a29e23912143b493$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    const activeInteraction = (0, $siTdT.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $2jbI6.classifyTerminalError)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $a29e23912143b493$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $lvzrB.getActiveTrace)()?.traceId ?? $a29e23912143b493$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $siTdT.PreviousInteractionLog).timestamp != null ? currentTime - (0, $siTdT.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $siTdT.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $siTdT.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $siTdT.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $7VWGN.default).current ?? null
    };
    $a29e23912143b493$var$sinkHandlerFn(errorData, context);
}
function $a29e23912143b493$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $7fzie.useInteractionContext)();
    const hasReportedRef = (0, $euxye.useRef)(false);
    (0, $euxye.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $a29e23912143b493$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
}

});
parcelRegister("2jbI6", function(module, exports) {
$parcel$export(module.exports, "classifyTerminalError", () => $43d59e9f1585bc2a$export$17e837b2daecf805);
const $43d59e9f1585bc2a$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $43d59e9f1585bc2a$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $43d59e9f1585bc2a$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $43d59e9f1585bc2a$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $43d59e9f1585bc2a$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $43d59e9f1585bc2a$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $43d59e9f1585bc2a$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $43d59e9f1585bc2a$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $43d59e9f1585bc2a$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $43d59e9f1585bc2a$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($43d59e9f1585bc2a$var$ABORT_ERROR_NAMES.has(name) || $43d59e9f1585bc2a$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $43d59e9f1585bc2a$var$AUTH_ERROR_NAMES.has(name) && $43d59e9f1585bc2a$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($43d59e9f1585bc2a$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($43d59e9f1585bc2a$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $43d59e9f1585bc2a$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($43d59e9f1585bc2a$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $43d59e9f1585bc2a$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($43d59e9f1585bc2a$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $43d59e9f1585bc2a$export$17e837b2daecf805(error) {
    const directMatch = $43d59e9f1585bc2a$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $43d59e9f1585bc2a$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}

});


parcelRegister("211nO", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $f9fbd4d570d19247$export$edb879ae55bb9be3);

var $iqfTZ = parcelRequire("iqfTZ");

var $ipvkO = parcelRequire("ipvkO");

var $jQqmM = parcelRequire("jQqmM");

var $cTH3O = parcelRequire("cTH3O");

var $lsOU0 = parcelRequire("lsOU0");

var $dqaa1 = parcelRequire("dqaa1");

var $1WGPj = parcelRequire("1WGPj");

var $1jtaq = parcelRequire("1jtaq");


var $4HRn5 = parcelRequire("4HRn5");

var $icsbC = parcelRequire("icsbC");

var $7ueIp = parcelRequire("7ueIp");

var $83Y4M = parcelRequire("83Y4M");

var $ckJnX = parcelRequire("ckJnX");

var $4vmTB = parcelRequire("4vmTB");

var $gz02O = parcelRequire("gz02O");

var $34B33 = parcelRequire("34B33");

var $3R7ke = parcelRequire("3R7ke");

var $4J9cE = parcelRequire("4J9cE");

var $1k1UE = parcelRequire("1k1UE");

var $iki03 = parcelRequire("iki03");

var $h8lRE = parcelRequire("h8lRE");

var $5chr4 = parcelRequire("5chr4");

var $4ZfOv = parcelRequire("4ZfOv");

var $1Ov7i = parcelRequire("1Ov7i");

var $9Zd6z = parcelRequire("9Zd6z");

var $fncjT = parcelRequire("fncjT");
const $f9fbd4d570d19247$var$UNKNOWN_VALUE = 'unknown';
const $f9fbd4d570d19247$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $f9fbd4d570d19247$var$UNKNOWN_VALUE,
    id: $f9fbd4d570d19247$var$UNKNOWN_VALUE,
    uuid: $f9fbd4d570d19247$var$UNKNOWN_VALUE,
    state: {
        id: $f9fbd4d570d19247$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $ipvkO.ExperienceTypes).Experience,
    category: $f9fbd4d570d19247$var$UNKNOWN_VALUE,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $1jtaq.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $f9fbd4d570d19247$var$Publisher {
    publish(data) {
        const payloadStart = (0, $1Ov7i.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $1WGPj.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$f9fbd4d570d19247$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $8312ee7c6ac197b8$export$93809551debf385f) || $f9fbd4d570d19247$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $34B33.eventBrowserPlugin)(),
                    ...(0, $3R7ke.eventCpusPlugin)(),
                    ...(0, $1k1UE.eventMemoryPlugin)(),
                    ...(0, $iki03.eventNetworkPlugin)(),
                    ...(0, $4vmTB.appFramework)(this.app),
                    ...(0, $gz02O.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $4HRn5.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $83Y4M.pageVisibleState)(supportedData),
                    ...(0, $fncjT.isInitialPageLoad)(supportedData) && (0, $5chr4.ssrSuccess)(this.ssr),
                    ...(0, $fncjT.isInitialPageLoad)(supportedData) && (0, $h8lRE.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $4J9cE.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $iqfTZ.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: (0, $1Ov7i.getPerformanceObject)()?.timeOrigin ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $1Ov7i.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $dqaa1.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $cTH3O.getGlobalEventStream)() instanceof (0, $icsbC.UFOGlobalEventStream))) {
            const eventStream = new (0, $icsbC.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $1jtaq.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $lsOU0.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $jQqmM.visibilityChangeObserver).start();
        (0, $ckJnX.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $7ueIp.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $f9fbd4d570d19247$var$UNKNOWN_VALUE;
        this.hostname = (0, $9Zd6z.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $4HRn5.TenantType).RealUser;
        this.app = {
            version: {
                web: $f9fbd4d570d19247$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $4ZfOv.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $f9fbd4d570d19247$export$edb879ae55bb9be3 = new $f9fbd4d570d19247$var$Publisher();

});
parcelRegister("lsOU0", function(module, exports) {
$parcel$export(module.exports, "setGlobalEventStream", () => $53cf829629125535$export$c1522520b417b066);

var $1WGPj = parcelRequire("1WGPj");
const $53cf829629125535$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $1WGPj.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};

});

// temp solution until a proper versioning
const $8312ee7c6ac197b8$export$93809551debf385f = '0.1.7';

parcelRegister("4HRn5", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $44caa20969a6d08c$export$92a757ac1398962f);

var $44caa20969a6d08c$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("icsbC", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $5131c4c9fd7ef452$export$faf4c91b80fc830e);

var $dqaa1 = parcelRequire("dqaa1");

var $1jtaq = parcelRequire("1jtaq");
class $5131c4c9fd7ef452$export$faf4c91b80fc830e {
    push(event) {
        (0, $dqaa1.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $1jtaq.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $1jtaq.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $1jtaq.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $1jtaq.SUBSCRIBE_ALL]) this.subscribers[0, $1jtaq.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $dqaa1.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("7ueIp", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $79b714b425809ac2$export$738d24377baf6a5e);

var $ipvkO = parcelRequire("ipvkO");

var $fncjT = parcelRequire("fncjT");

var $lpbLB = parcelRequire("lpbLB");

var $jYRff = parcelRequire("jYRff");

var $dWjEf = parcelRequire("dWjEf");

var $aG8Xq = parcelRequire("aG8Xq");

var $88ddY = parcelRequire("88ddY");

var $fSUsb = parcelRequire("fSUsb");

var $5PyuP = parcelRequire("5PyuP");
const $79b714b425809ac2$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $ipvkO.ExperiencePerformanceTypes).PageLoad:
        case (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad:
            return (0, $dWjEf.getLoadMetrics)(data, ssr, performanceConfig);
        case (0, $ipvkO.ExperiencePerformanceTypes).InlineResult:
            return (0, $jYRff.getInlineResultMetrics)(data, performanceConfig);
        case (0, $ipvkO.ExperiencePerformanceTypes).Custom:
            return (0, $lpbLB.getCustomMetrics)(data, performanceConfig);
    }
};
const $79b714b425809ac2$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$79b714b425809ac2$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $5PyuP.resourceTimings)(data, resourceConfig),
        ...(0, $fSUsb.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $88ddY.appTimings)(data, ssr),
        ...(0, $fncjT.isInitialPageLoad)(data) ? (0, $aG8Xq.navigationMetrics)() : null
    };
};

});
parcelRegister("fncjT", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $c0a5c5a49a8e1053$export$7167d96e9881d500);

var $ipvkO = parcelRequire("ipvkO");
const $c0a5c5a49a8e1053$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $ipvkO.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("lpbLB", function(module, exports) {
$parcel$export(module.exports, "getCustomMetrics", () => $02cac5bf5386cca1$export$c25c1b3ff2ce92cf);

var $2AP9A = parcelRequire("2AP9A");

var $dYsh3 = parcelRequire("dYsh3");
const $02cac5bf5386cca1$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [(0, $2AP9A.CustomMetricKeys).duration]: Math.round(duration),
        ...(0, $dYsh3.getHistogram)(data, performanceConfig)
    };
};

});
parcelRegister("2AP9A", function(module, exports) {
$parcel$export(module.exports, "CustomMetricKeys", () => $adcd4e44e420f17c$export$8b4d49d876b19889);
const $adcd4e44e420f17c$export$8b4d49d876b19889 = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};

});

parcelRegister("dYsh3", function(module, exports) {
$parcel$export(module.exports, "getHistogram", () => $752dab80cc89796e$export$908946735178c541);

var $ipvkO = parcelRequire("ipvkO");

var $2AP9A = parcelRequire("2AP9A");

var $Tyzpq = parcelRequire("Tyzpq");

var $jwEuR = parcelRequire("jwEuR");
const $752dab80cc89796e$export$908946735178c541 = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $ipvkO.ExperiencePerformanceTypes).PageLoad:
            case (0, $ipvkO.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [(0, $jwEuR.LoadMetricKeys).ttiHistograms]: histograms[histogramType].tti,
                    [(0, $jwEuR.LoadMetricKeys).fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $ipvkO.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [(0, $Tyzpq.InlineResultMetricKeys).resultHistograms]: histograms.result,
                    [(0, $Tyzpq.InlineResultMetricKeys).responseHistograms]: histograms.response
                } : {};
            case (0, $ipvkO.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [(0, $2AP9A.CustomMetricKeys).durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};

});
parcelRegister("Tyzpq", function(module, exports) {
$parcel$export(module.exports, "InlineResultMetricKeys", () => $a60af9220046fda6$export$1bc754b4266cc540);
const $a60af9220046fda6$export$1bc754b4266cc540 = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};

});

parcelRegister("jwEuR", function(module, exports) {
$parcel$export(module.exports, "LoadMetricKeys", () => $e4795c13dc9db493$export$6869ee9ee4309612);
const $e4795c13dc9db493$export$6869ee9ee4309612 = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};

});



parcelRegister("jYRff", function(module, exports) {
$parcel$export(module.exports, "getInlineResultMetrics", () => $12c8b36b272b9459$export$47f0208fd62dffce);

var $1jtaq = parcelRequire("1jtaq");

var $dYsh3 = parcelRequire("dYsh3");

var $Tyzpq = parcelRequire("Tyzpq");
const $12c8b36b272b9459$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $1jtaq.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [(0, $Tyzpq.InlineResultMetricKeys).result]: Math.round(result),
        [(0, $Tyzpq.InlineResultMetricKeys).response]: Math.round(response),
        ...(0, $dYsh3.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("dWjEf", function(module, exports) {
$parcel$export(module.exports, "getLoadMetrics", () => $1e3af81db35d44cd$export$bd4e6d81a822ece6);

var $1jtaq = parcelRequire("1jtaq");

var $fncjT = parcelRequire("fncjT");

var $dYsh3 = parcelRequire("dYsh3");

var $jwEuR = parcelRequire("jwEuR");
const $1e3af81db35d44cd$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $1jtaq.FMP_MARK))?.time || (0, $fncjT.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [(0, $jwEuR.LoadMetricKeys).tti]: Math.round(tti),
        [(0, $jwEuR.LoadMetricKeys).fmp]: Math.round(fmp),
        ...(0, $dYsh3.getHistogram)(data, performanceConfig)
    };
};

});

parcelRegister("aG8Xq", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $76bb58d472f6ce3d$export$b88d990436be0f8a);
const $76bb58d472f6ce3d$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("88ddY", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $46e0ea8b3810611b$export$e952f50a4f2d02da);

var $ipvkO = parcelRequire("ipvkO");

var $fncjT = parcelRequire("fncjT");

var $lIkzm = parcelRequire("lIkzm");

var $1L30n = parcelRequire("1L30n");
const $46e0ea8b3810611b$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $ipvkO.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $lIkzm.customTimings)(data);
    const ssr = (0, $fncjT.isInitialPageLoad)(data) ? (0, $1L30n.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("lIkzm", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $d09ff5d3ed2036cc$export$6126f85083a72c6e);
const $d09ff5d3ed2036cc$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $d09ff5d3ed2036cc$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $d09ff5d3ed2036cc$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("1L30n", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $fdca1a35ddb46c58$export$130f411261a599c5);

const $fdca1a35ddb46c58$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $fdca1a35ddb46c58$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $fdca1a35ddb46c58$var$SSR_PREFIX = 'ssr';
const $fdca1a35ddb46c58$var$mapKey = (key)=>{
    if (key === 'total') return $fdca1a35ddb46c58$var$SSR_PREFIX;
    return `${$fdca1a35ddb46c58$var$SSR_PREFIX}${0, $dd841321bc924872$export$b98e411ae80c806f}${key}`;
};
const $fdca1a35ddb46c58$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($fdca1a35ddb46c58$var$filterEntry(entry[1])) acc[$fdca1a35ddb46c58$var$mapKey(entry[0])] = $fdca1a35ddb46c58$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $dd841321bc924872$export$b98e411ae80c806f = '/';



parcelRegister("fSUsb", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $07b644d222635f22$export$1a2bb347935fc536);

var $1Ov7i = parcelRequire("1Ov7i");
const $07b644d222635f22$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $1Ov7i.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("1Ov7i", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObject", () => $7cda65811815de84$export$8cd0c777b0eb66a0);

var $9Zd6z = parcelRequire("9Zd6z");
const $7cda65811815de84$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = (0, $9Zd6z.getWindowObject)() || {};
    return performance;
};

});
parcelRegister("9Zd6z", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $98e16dd1fb93dc18$export$9aa44f85591248d9);
const $98e16dd1fb93dc18$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};

});



parcelRegister("5PyuP", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $1d9cf432e8e185a2$export$81a7d52441a06b50);

var $1Ov7i = parcelRequire("1Ov7i");

var $9Zd6z = parcelRequire("9Zd6z");

var $ckJnX = parcelRequire("ckJnX");
const $1d9cf432e8e185a2$var$cacheableTypes = [
    'script',
    'link'
];
const $1d9cf432e8e185a2$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $1d9cf432e8e185a2$var$CACHE_NETWORK = 'network';
const $1d9cf432e8e185a2$var$CACHE_MEMORY = 'memory';
const $1d9cf432e8e185a2$var$CACHE_DISK = 'disk';
const $1d9cf432e8e185a2$var$calculateTransferType = (type, duration, size)=>{
    if (!$1d9cf432e8e185a2$var$cacheableTypes.includes(type)) return $1d9cf432e8e185a2$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $1d9cf432e8e185a2$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $1d9cf432e8e185a2$var$CACHE_DISK;
    if (size === undefined) return null;
    return $1d9cf432e8e185a2$var$CACHE_NETWORK;
};
const $1d9cf432e8e185a2$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$1d9cf432e8e185a2$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $9Zd6z.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $1d9cf432e8e185a2$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $1d9cf432e8e185a2$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $1d9cf432e8e185a2$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $1d9cf432e8e185a2$var$getNetworkData = (item, eventStart, hasTimingHeaders = $1d9cf432e8e185a2$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$1d9cf432e8e185a2$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($1d9cf432e8e185a2$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $1d9cf432e8e185a2$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$1d9cf432e8e185a2$var$getSizeObject(transferSize)
        };
        if (transferType !== $1d9cf432e8e185a2$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$1d9cf432e8e185a2$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$1d9cf432e8e185a2$var$getSizeObject(transferSize)
    };
};
const $1d9cf432e8e185a2$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $1Ov7i.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $ckJnX.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $1d9cf432e8e185a2$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $1d9cf432e8e185a2$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$1d9cf432e8e185a2$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("ckJnX", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $8bb030fe24459c6c$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $8bb030fe24459c6c$export$9eebb59359c2e9e5);
// @flow strict-local

var $d4ULW = parcelRequire("d4ULW");

var $1Ov7i = parcelRequire("1Ov7i");

var $gxOlI = parcelRequire("gxOlI");
const $8bb030fe24459c6c$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $1Ov7i.getPerformanceObject)(), PerformanceObserver1 = (0, $gxOlI.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($8bb030fe24459c6c$export$bea963256235a63e.observer) {
            (0, $d4ULW.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $8bb030fe24459c6c$export$bea963256235a63e.timings = resources.map((resource)=>$8bb030fe24459c6c$export$bea963256235a63e.transformResource(resource));
        $8bb030fe24459c6c$export$bea963256235a63e.observer = new PerformanceObserver1($8bb030fe24459c6c$export$bea963256235a63e.addTimings);
        $8bb030fe24459c6c$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($8bb030fe24459c6c$export$bea963256235a63e.observer) {
            $8bb030fe24459c6c$export$bea963256235a63e.observer.disconnect();
            $8bb030fe24459c6c$export$bea963256235a63e.observer = null;
        }
        $8bb030fe24459c6c$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$8bb030fe24459c6c$export$bea963256235a63e.transformResource(entry));
        const overflow = $8bb030fe24459c6c$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $8bb030fe24459c6c$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $8bb030fe24459c6c$export$bea963256235a63e.maxSize;
            $8bb030fe24459c6c$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $8bb030fe24459c6c$export$bea963256235a63e.timings.push(...entries);
    }
};
const $8bb030fe24459c6c$export$9eebb59359c2e9e5 = (startTime, performance = (0, $1Ov7i.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$8bb030fe24459c6c$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $8bb030fe24459c6c$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});
parcelRegister("gxOlI", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserverObject", () => $0f8c985c36ea7297$export$74560fd4e61fd440);

var $9Zd6z = parcelRequire("9Zd6z");
const $0f8c985c36ea7297$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = (0, $9Zd6z.getWindowObject)() || {};
    return PerformanceObserver;
};

});




parcelRegister("83Y4M", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $5894d3f48cae862a$export$723b4c298aca63af);

var $1jtaq = parcelRequire("1jtaq");
const $5894d3f48cae862a$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $1jtaq.PageVisibleState).HIDDEN : (0, $1jtaq.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("4vmTB", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $0d3b99a53c3a0271$export$e34e4529b979f74c);
const $0d3b99a53c3a0271$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("gz02O", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $37186d3664e7da14$export$82ae485178b37419);
const $37186d3664e7da14$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("34B33", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $e330445ceeb743c4$export$f435c2789ca334a7);

var $9njAx = parcelRequire("9njAx");

var $emCaV = parcelRequire("emCaV");

var $9Zd6z = parcelRequire("9Zd6z");
const $e330445ceeb743c4$export$f435c2789ca334a7 = (0, $emCaV.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9njAx))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($9njAx))).getParser((0, $9Zd6z.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("3R7ke", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $51342e178006b221$export$db7649b8854107ad);

var $emCaV = parcelRequire("emCaV");
const $51342e178006b221$export$db7649b8854107ad = (0, $emCaV.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("4J9cE", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $b39c424e2ad4544f$export$e62953d023125748);
const $b39c424e2ad4544f$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("1k1UE", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $e9665f4e97def69f$export$81efaf8414879a1a);

var $emCaV = parcelRequire("emCaV");
const $e9665f4e97def69f$export$81efaf8414879a1a = (0, $emCaV.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("iki03", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $d31727ba5e1a4599$export$ce1cf816dce1da56);
const $d31727ba5e1a4599$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("h8lRE", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $838e83b78d6ed319$export$fdbea518c19dfa8);
const $838e83b78d6ed319$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("5chr4", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $c08715ed6a28c31f$export$a3dc8251cf55b2e0);
const $c08715ed6a28c31f$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("4ZfOv", function(module, exports) {
$parcel$export(module.exports, "Route", () => $65f7fd5a31d975dd$export$e7b0ac011bb776c6);
const $65f7fd5a31d975dd$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


$parcel$global.rlb("15ZAZ")
//# sourceMappingURL=shared~commons~atlassian~ar.94f76bc6.js.map
